// Copyright (c) 2021 Deere & Company

import React, {PropTypes} from 'react';
import AdditionalFields from './additional-fields';
import DealershipWithModal from '../../../shared/components/dealership-detail-modal';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRates from './labor-rates';

const LaborRateMain = props =>
    <div className='labor-rate-change-panel'>
        <header>
            <span className='dealer-location'>
                <DealershipWithModal
                    isDealershipModalOpen={props.isDealershipModalOpen}
                    laborRateAll={props.laborRateAll}
                    onDealershipModalClose={props.onDealershipModalClose}
                    onDealershipModalOpen={props.onDealershipModalOpen}
                />
            </span>
        </header>
        <LaborRates
            actions={props.actions}
            queryParamRequstID={props.queryParamRequstID}
            rates={props.laborRate.rates}
            tcsm={props.tcsm}
        />
        <AdditionalFields
            actions={props.actions}
            laborRate={props.laborRate}
            tcsm={props.tcsm}
        >
            {props.children}
        </AdditionalFields>
    </div>;

LaborRateMain.displayName = 'LaborRateMain';
LaborRateMain.propTypes = {
    actions: PropTypes.object.isRequired,
    children: PropTypes.node,
    isDealershipModalOpen: PropTypes.bool.isRequired,
    laborRate: PropTypes.instanceOf(LaborRate).isRequired,
    laborRateAll: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    onDealershipModalClose: PropTypes.func.isRequired,
    onDealershipModalOpen: PropTypes.func.isRequired,
    queryParamRequstID: PropTypes.string.isRequired,
    tcsm: PropTypes.bool.isRequired
};

export default LaborRateMain;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/components/labor-rate-main.js